// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const middlewareTokkoApi = createApi({
  reducerPath: 'middlewareTokkoApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://dv-tokko.mediahaus.com.ar/api/v1/tokko/',
  }),
  endpoints: () => ({}),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
